import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { CopyToClipboard } from "../../../../utils/CommonHelper";
import * as actions from "../../redux/SettingAction";

export const ContactUs = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const [swalProps, setSwalProps] = useState({});

  useEffect(() => {
    dispatch(actions.getContactList({ action: "contactlist" }));
  }, []);

  return (
    <>
      <SweetAlert2
        heightAuto={false}
        onResolve={() => {
          setSwalProps({});
        }}
        backdrop={false}
        {...swalProps}
        customClass="custom-swal"
      />
      <div style={styles.navBar} className="position-relative">
        <div style={styles.backButton}></div>
        <div style={styles.title} className="text-font4">
          {intl.formatMessage({ id: "contactUs" })}
        </div>
      </div>
      <div>
        {settingState.contactList ? (
          <>
            {settingState.contactList.contactLists.map((contactList, index) => (
              <div
                key={index}
                className={`custom-border rounded px-3 py-4 ${
                  contactList.isurl === "true"
                    ? "cursor-pointer"
                    : "d-flex align-items-center justify-content-between"
                }`}
                onClick={() => {
                  if (contactList.isurl === "true") {
                    window.open(contactList.contact);
                  }
                }}
                style={{
                  backgroundColor: "rgba(255,255,255,0.02)",
                  width: "94%",
                  margin: "10px auto",
                  padding: "5px",
                  color: "white",
                  fontSize: "12px",
                  borderRadius: "5px",
                }}
              >
                <div>
                  <div className="mb-3 fw-bold ">{contactList.channelname}</div>
                  <div>{contactList.contact}</div>
                </div>
                {contactList.isurl !== "true" && (
                  <i
                    className="ms-2 fs-3 fa fa-copy cursor-pointer"
                    style={{ color: "white" }}
                    onClick={() => {
                      if (sessionStorage.getItem("platform") === "mobile") {
                        CopyToClipboard(
                          contactList.contact,
                          setSwalProps,
                          intl
                        );
                      } else {
                        CopyToClipboard(
                          contactList.contact,
                          setSwalProps,
                          intl
                        );
                      }
                    }}
                  />
                )}
              </div>
            ))}
          </>
        ) : (
          <Skeleton className="w-100" height="600px" />
        )}
      </div>
    </>
  );
};

const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
